import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography, Box, Divider } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import { CircularProgress } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TablePagination from '@material-ui/core/TablePagination'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import * as _ from 'lodash'

import { GLOBAL_ATTENTION_INDEX_1 } from '../../constants/colors'
import { DISTRIBUTION_LABELS } from '../../constants/labels'
import { TableFormats } from '../TableHelpers'

const BorderLinearProgressPrimary = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: GLOBAL_ATTENTION_INDEX_1
  }
}))(LinearProgress)

export class GlobalAttentionDistributorComponent extends Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    classes: PropTypes.object.isRequired,
    attentionIndexDetails: PropTypes.object,
    setSelectedDistributions: PropTypes.func,
    selectedDistributions: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetworkByDistributor: null,
      page: 0,
      rowsPerPage: 3,
      distributionList: null
    }
  }

  componentDidMount () {
    if (this.props.attentionIndexDetails) {
      this.setDistributionListByEngagement()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.attentionIndexDetails !== this.props.attentionIndexDetails) {
      this.setState({
        page: 0
      })
      this.setDistributionListByEngagement()
    }
  }

  setDistributionListByEngagement = () => {
    const details = this.props.attentionIndexDetails && this.props.attentionIndexDetails.details ? this.props.attentionIndexDetails.details : []
    let distributionList = []
    let detail = null
    DISTRIBUTION_LABELS.split(',').map(distribution => {
      if (distribution === 'Others') {
        detail = details.filter(detail => !detail.distributions || (detail.distributions && (detail.distributions.indexOf('Streaming') < 0 && detail.distributions.indexOf('Linear') < 0 && detail.distributions.indexOf('Theatrical Release') < 0)))
      } else {
        detail = details.filter(detail => detail.distributions && detail.distributions.indexOf(distribution) > -1)
      }
      if (detail && detail.length > 0)
      {
        detail.map(e => {
          distributionList.push({
            'network': distribution,
            'score': e.score ? e.score : 0
            })
        })
      } else {
        distributionList.push({
          'network': distribution,
          'score': 0
          })
      }
    })
    let totalVolume = distributionList.reduce((total, gen) => total + gen.score, 0)
    let distributionListByScore = _(distributionList)
    .groupBy('network')
    .map((g, network) => ({network, value: _.sumBy(g, 'score'), percentage: (_.sumBy(g, 'score') / totalVolume) * 100})).orderBy('score', 'desc')
    .value()
    distributionListByScore.pop()
    distributionListByScore = distributionListByScore.sort((a, b) => b.value - a.value)
    this.setState({ distributionList: distributionListByScore})
  }

  render () {
    const { classes, selectedDistributions } = this. props
    const { distributionList } = this.state

    const charLength = this.props.screenWidth < 375 ? 10 : this.props.screenWidth >= 375 && this.props.screenWidth < 479.95 ? 20
    : this.props.screenWidth >= 480 && this.props.screenWidth < 767.98 ? 50
    : this.props.screenWidth >= 768 && this.props.screenWidth < 1023.98 ? 40
    : this.props.screenWidth >= 1024 && this.props.screenWidth < 1199.98 ? 30
    : this.props.screenWidth >= 1200 && this.props.screenWidth < 1439.98 ? 20
    : (this.props.screenWidth >= 1440)
    ? 30 : 30

    const handleChangePage = (event, page) => {
      this.setState({page: page})
    }

    const titleWithTooltip = (title) => {
      if (title && title.length > charLength) {
        const tooltip = <Tooltip id="tooltip">{title}</Tooltip>
        return (
          <OverlayTrigger overlay={tooltip} placement='top'>
            <span className="txt">{title.substring(0, charLength)}...</span>
          </OverlayTrigger>
        )
      }
      return (<span>{title}</span>)
    }

    return (
      <Paper className={`metricBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`metricTitle ${classes.cardTitle}`}>Top distribution type by engagement</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{'Top distribution type by engagement'}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
        </Grid>
        { distributionList ?
          distributionList.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row, index) =>(
            <Box className={`${index === 0 && 'boxStart'} primary`} key={index}>
              <Box className={`${selectedDistributions.filter(e => e === row.network).length > 0 ? 'selected-distribution' : ''} d-flex align-items-center cursorPointer topEngagementFilter`} onClick={() => this.props.setSelectedDistributions(row.network)}>
                <Box className="w-30">
                  <Typography className="metricProLabel cardOne">{titleWithTooltip(row.network)}</Typography>
                </Box>
                <Box className="w-40 progressRotate">
                  <BorderLinearProgressPrimary variant="determinate" value={row.percentage ? row.percentage : 0} sx={{direction: 'rtl'}} />
                </Box>
                <Box className="w-30 text-right">
                  <Typography className="metricProLabel cardOne">{TableFormats.trackerFormatKM(row.value)} ({row.percentage && row.percentage >= 1 ? Math.round(row.percentage * 10) / 10 : row.percentage ? Math.round(row.percentage * 100) / 100 : 0}%)</Typography>
                </Box>
              </Box>
              { index !== 2 &&
                <Divider className="progressDivide"/>
              }
            </Box>
          )) :
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        <Table className='tableFooter'>
          <TableBody>
            <TableRow>
              <TablePagination
                rowsPerPageOptions= {[3, 6, 9]}
                count={distributionList ? distributionList.length : 3}
                rowsPerPage={3}
                page={this.state.page}
                onChangePage={handleChangePage}
                labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}}`} results`}
              />
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default withStyles(styles)(GlobalAttentionDistributorComponent)
